import { render, staticRenderFns } from "./PageAccountForgetPasswordV2.vue?vue&type=template&id=1887e361&scoped=true&"
import script from "./PageAccountForgetPasswordV2.vue?vue&type=script&lang=js&"
export * from "./PageAccountForgetPasswordV2.vue?vue&type=script&lang=js&"
import style0 from "./PageAccountForgetPasswordV2.vue?vue&type=style&index=0&id=1887e361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887e361",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VForm,VIcon,VProgressCircular,VTextField})
